import { useEffect } from "react"
import { Button, Grid } from "@mui/material"
import { useParams } from 'react-router-dom';
import { BRAND_NAME } from "../../config/constants";

const Message = () => {
    const { uidb64 } = useParams();
    const { token } = useParams();

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + `/api/activate/${uidb64}/${token}/`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        })
        // eslint-disable-next-line
    }, [])


    return (

        <Grid container style={{ marginTop: 200, fontFamily: 'Raleway' }}>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
                Congrats on creating your {BRAND_NAME} account
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
                You have credited with a time bank balance 1.0
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center' }} >
                <Button href='/login' style={{ backgroundColor: 'orange', color: 'white' }}>Login</Button>
            </Grid>
        </Grid>
    )



}

export default Message